var map = {
	"./about.svg": 375,
	"./analytics.svg": 376,
	"./comdi.svg": 377,
	"./experience.svg": 378,
	"./faq.svg": 379,
	"./faq_and_support.svg": 380,
	"./form.svg": 381,
	"./icons.svg": 382,
	"./main--devices.svg": 383,
	"./mts.svg": 384,
	"./numbers.svg": 385,
	"./partners.svg": 386,
	"./premise.svg": 387,
	"./products-meetings.svg": 388,
	"./products-messenger.svg": 389,
	"./products-on-premise.svg": 390,
	"./products-rooms.svg": 391,
	"./products-webinars.svg": 392,
	"./products-westudy.svg": 393,
	"./products.svg": 394,
	"./services.svg": 395,
	"./sidebar.svg": 396,
	"./social.svg": 397,
	"./tariffs.svg": 398,
	"./task-education.svg": 399,
	"./task-healthcare.svg": 400,
	"./task-med.svg": 401,
	"./task-nmo.svg": 402,
	"./task-ouz.svg": 403,
	"./task-pharma.svg": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;